import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import store from '../store'

const qs = {
  stringify: function(data) {
    if (!data) {
      return ''
    }
    let ret = ''
    for (const it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    ret = ret.substring(0, ret.lastIndexOf('&'))
    return ret
  }
}

let hasloginout = false
const { VUE_APP_API_BASE_URL } = process.env
class HttpRequest {
  constructor() {
    this.baseUrl = VUE_APP_API_BASE_URL
    this.timeout = 60000
  }

  setInterceptors(instance) {
    instance.interceptors.request.use(config => {
      config.headers.Authorization = store.getters.authorization || ''
      return config
    })
    instance.interceptors.response.use(res => {
      // console.log('fetch-origin', res)
      const data = res.data
      if (res.status === 200) {
        if ([5002, 401].includes(Number(data.code))) {
          if (!hasloginout) {
            Message({
              message: data.message || '出现错误，请稍后再试',
              type: 'error',
              duration: 5 * 1000
            })
          }
          hasloginout = true
          setTimeout(function() {
            router.push('/login')
          })
          return false
        } else if ([400].includes(Number(data.code))) {
          if (!hasloginout) {
            Message({
              message: data.message || '出现错误，请稍后再试',
              type: 'error',
              duration: 5 * 1000
            })
          }
          // hasloginout = true
          return false
        }
        if (hasloginout) {
          hasloginout = false
        }
        return Promise.resolve(data)
      } else {
        hasloginout = false
        return Promise.reject(data)
      }
    }, err => {
      switch (err.response.status) {
        case '401':
          // todo 401
          break
        default:
          break
      }
      return Promise.reject(err)
    })
  }

  mergeOptions(options) {
    return {
      baseUrl: this.baseUrl,
      timeout: this.timeout,
      ...options,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  }

  request(options) {
    const instance = axios.create()
    this.setInterceptors(instance)
    const opts = this.mergeOptions(options)
    return instance(opts)
  }

  get(url, config) {
    return this.request({
      method: 'get',
      url,
      ...config
    })
  }

  downloadGet(url, config) {
    return this.request({
      method: 'get',
      url,
      ...config,
      responseType: 'arraybuffer'
    })
  }

  post(url, data) {
    return this.request({
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      url,
      data
    })
  }

  delete(url, data) {
    return this.request({
      method: 'delete',
      url,
      data
    })
  }

  delete2(url, config) {
    return this.request({
      method: 'delete',
      url,
      ...config
    })
  }

  put(url, data) {
    return this.request({
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      url,
      data
    })
  }

  // formData
  put2(url, data) {
    return this.request({
      method: 'put',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url,
      data: qs.stringify(data)
    })
  }
}

export default new HttpRequest()
